import { Create, useForm } from '@refinedev/antd';
import { message } from 'antd';
import { useState } from 'react';

import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

import ShipmentForm from './ShipmentForm/ShipmentForm';

export const ShipmentCreate = () => {
  const { packageRepository, packageItemRepository } = useRepositoriesContext();
  const [saveAddress, setSaveAddress] = useState(false);
  const [packageItems, setPackageItems] = useState<PackageItem[]>([]);
  const { formProps, saveButtonProps } = useForm<Shipment>({
    successNotification: {
      message: 'Envío creado correctamente',
      type: 'success',
    },
    onMutationSuccess(shipmentResponse) {
      if (saveAddress) {
        void packageRepository.saveNewAddress(shipmentResponse.data).catch(error => {
          message.error('Ocurrió un error al guardar la nueva dirección.');
          console.error('Error saving new address:', error);
        });
      }

      void packageItemRepository
        .savePackageItems(packageItems, shipmentResponse.data.id)
        .catch(error => {
          message.error('Ocurrió un error al guardar los items del envío.');
          console.error('Error saving package items:', error);
        });
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <ShipmentForm
        formProps={formProps}
        saveAddress={saveAddress}
        setSaveAddress={setSaveAddress}
        packageItems={packageItems}
        setPackageItems={setPackageItems}
      />
    </Create>
  );
};
